module.exports = __webpack_public_path__ + "img/loading.b7e8a526.svg";